var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSirenStandby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23D4FF",
    d: "M7.12 0c.6 0 1.085.472 1.085 1.055v15.89c0 .583-.486 1.055-1.085 1.055-.598 0-1.084-.472-1.084-1.055V1.055C6.036.472 6.522 0 7.12 0zM4.952 2.665v12.67c-.67-.968-1.805-1.589-3.075-1.589H0V4.254h1.877c1.27 0 2.406-.62 3.075-1.59zm4.337 3.23l2.711.88v4.45l-2.71.88v-6.21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirenStandby);
export default __webpack_public_path__ + "static/media/siren-standby.ce306f9a7b98f3951a6d3a9eed0d7f18.svg";
export { ForwardRef as ReactComponent };